<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            CONTRATO -
                            <strong
                                >{{ contrato.vcCodigoEstruturado }} -
                                {{
                                    contrato.fornecedor
                                        ? contrato.fornecedor.nome
                                        : ''
                                }}</strong
                            >
                            <b-badge variant="warning" class="ml-2">{{
                                operacao
                            }}</b-badge>
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <app-erros-box
                            :erros="erros"
                            v-if="erros.length > 0"
                        ></app-erros-box>
                        <b-tabs pills card vertical v-model="tabIndex">
                            <b-tab title="Dados Gerais" active class="pb-0">
                                <app-contrato-dados-gerais
                                    v-if="$temAcessoView('CONT-01')"
                                    :contrato="contrato"
                                ></app-contrato-dados-gerais>
                            </b-tab>
                            <b-tab title="Itens de Contrato" class="pb-0">
                                <app-itens-contrato
                                    :contrato="contrato"
                                    @obterContratoAtualizado="
                                        obterContratoAtualizado(true)
                                    "
                                ></app-itens-contrato>
                            </b-tab>
                            <b-tab title="Documentos" class="pb-0">
                                <app-documentos
                                    :contrato="contrato"
                                    @obterDocumentosAtualizados="
                                        obterDocumentosAtualizados()
                                    "
                                ></app-documentos>
                            </b-tab>
                            <b-tab title="Responsáveis" class="pb-0">
                                <app-contrato-responsaveis
                                    :contrato="contrato"
                                    @obterResponsaveisAtualizados="
                                        obterResponsaveisAtualizados()
                                    "
                                ></app-contrato-responsaveis>
                            </b-tab>
                            <b-tab title="Dados RM" class="pb-0">
                                <AppDadosRm
                                    v-if="$temAcessoView('CONT-01')"
                                    :contrato="contrato"
                                ></AppDadosRm>
                            </b-tab>
                            <b-tab title="Fases do Contrato" class="pb-0">
                                <app-fases-contrato
                                    :contrato="contrato"
                                    @obterFasesAtualizadas="
                                        obterFasesAtualizadas()
                                    "
                                    @obterApostilamentosAtualizados="
                                        obterApostilamentosAtualizados()
                                    "
                                    @obterComprometimentosAtualizados="
                                        obterComprometimentosAtualizados()
                                    "
                                ></app-fases-contrato>
                            </b-tab>
                            <b-tab title="Dotações Orçamentárias" class="pb-0">
                                <app-dotacoes-orcamentarias
                                    :contrato="contrato"
                                    @obterDotacoesAtualizadas="
                                        obterDotacoesAtualizadas()
                                    "
                                ></app-dotacoes-orcamentarias>
                            </b-tab>
                            <b-tab
                                title="Comprometimentos"
                                class="pb-0"
                                v-if="
                                    !contratoElaboracao &&
                                    !aditivoContratoIniciado
                                "
                            >
                                <comprometimentos
                                    ref="comprometimentos"
                                    :contrato="contrato"
                                ></comprometimentos>
                            </b-tab>
                            <!-- <b-tab title="Aditivos" class="pb-0" :disabled="true"></b-tab> -->
                            <b-tab
                                title="Apostilamento"
                                class="pb-0"
                                v-if="
                                    !contratoElaboracao &&
                                    !aditivoContratoIniciado
                                "
                            >
                                <app-contrato-apostilamentos
                                    :contrato="contrato"
                                ></app-contrato-apostilamentos>
                            </b-tab>
                            <b-tab title="Ocorrências Internas" class="pb-0">
                                <ocorrencias-internas
                                    :contrato="contrato"
                                ></ocorrencias-internas>
                            </b-tab>
                            <b-tab
                                title="Penalidades"
                                class="pb-0"
                                v-if="
                                    $temAcessoView('CONT-PENAL-00') &&
                                    !contratoElaboracao &&
                                    !aditivoContratoIniciado
                                "
                            >
                                <penalidades
                                    :contrato="contrato"
                                    @atualizarPenalidades="
                                        contrato.penalidades = $event
                                    "
                                ></penalidades>
                            </b-tab>
                            <b-tab
                                title="Histórico"
                                class="pb-0"
                                v-if="contrato.qtdAditivos > 0"
                            >
                                <historico-aditivos
                                    :contrato="contrato"
                                ></historico-aditivos>
                            </b-tab>
                            <b-tab
                                title="Avaliações"
                                class="pb-0"
                                v-if="contrato.avaliacoes"
                            >
                                <avaliacoes :contrato="contrato"></avaliacoes>
                            </b-tab>
                        </b-tabs>
                    </b-card-body>
                    <b-card-footer>
                        <b-button variant="danger" @click.stop="voltar()">
                            <span>
                                <i class="fa fa-history mr-2"></i> Voltar
                            </span>
                        </b-button>
                        <b-button
                            variant="primary"
                            @click.stop="apostilarContrato()"
                            class="ml-1"
                            v-if="mostrarBtnApostilar"
                        >
                            <span>
                                <i class="fa fa-edit mr-2"></i> Apostilar dados
                                gerais
                            </span>
                        </b-button>
                        <b-button
                            variant="primary"
                            @click.stop="AtualizarContrato()"
                            class="ml-1"
                            v-if="mostrarBtnAtualizarElab"
                        >
                            <span>
                                <i class="fa fa-edit mr-2"></i> Atualizar
                            </span>
                        </b-button>
                        <b-button
                            variant="primary"
                            @click.stop="AtualizarDadosRM()"
                            class="ml-1"
                            v-if="mostrarBtnAtualizarDadosRM"
                        >
                            <span>
                                <i class="fa fa-edit mr-2"></i> Atualizar
                            </span>
                        </b-button>
                        <b-button
                            variant="primary"
                            @click.stop="AtualizarContrato()"
                            class="ml-1"
                            v-if="mostrarBtnAtualizarAditivo"
                        >
                            <span>
                                <i class="fa fa-edit mr-2"></i> Atualizar
                            </span>
                        </b-button>
                        <btn-alternar-contrato
                            :contrato="contrato"
                            @obterContratoAtualizado="
                                obterContratoAtualizado(true)
                            "
                            @retornarParaLista="retornarParaLista(true)"
                            @atualizarMensagensErros="erros = $event"
                            v-if="mostrarBtnAlternarContrato"
                        ></btn-alternar-contrato>
                        <btn-encerrar-contrato
                            :contrato="contrato"
                            @obterContratoAtualizado="
                                obterContratoAtualizado(true)
                            "
                            @atualizarMensagensErros="erros = $event"
                            v-if="mostrarBtnEncerrarContrato"
                        ></btn-encerrar-contrato>
                        <btn-cancelar-contrato
                            :contrato="contrato"
                            @obterContratoAtualizado="
                                obterContratoAtualizado(true)
                            "
                            @atualizarMensagensErros="erros = $event"
                            v-if="mostrarBtnCancelarContrato"
                        ></btn-cancelar-contrato>
                        <btn-distribuir-contrato
                            :contrato="contrato"
                            v-if="mostrarBtnDistribuirContrato"
                            @obterContratoAtualizado="
                                obterContratoAtualizado(true)
                            "
                        >
                        </btn-distribuir-contrato>
                        <btn-distribuir-aditivo-contrato
                            :contrato="contrato"
                            v-if="mostrarBtnDistribuirAditivoContrato"
                            @obterContratoAtualizado="
                                obterContratoAtualizado(true)
                            "
                        >
                        </btn-distribuir-aditivo-contrato>
                        <b-button
                            variant="primary"
                            @click.stop="AditivarContrato()"
                            class="ml-1"
                            v-if="mostrarBtnAditivarContrato"
                        >
                            <span>
                                <i class="fa fa-plus mr-2"></i> Iniciar aditivo
                                contrato
                            </span>
                        </b-button>
                        <btn-integrar-contrato
                            :contrato="contrato"
                            v-if="mostrarBtnIntegrarContrato"
                            @obterContratoAtualizado="
                                obterContratoAtualizado(true)
                            "
                            @atualizarMensagensErros="erros = $event"
                        >
                        </btn-integrar-contrato>
                        <btn-integrar-aditivo-contrato
                            :contrato="contrato"
                            v-if="mostrarBtnIntegrarAditivoContrato"
                            @obterContratoAtualizado="
                                obterContratoAtualizado(true)
                            "
                        >
                        </btn-integrar-aditivo-contrato>
                        <b-button
                            variant="primary"
                            @click.stop="AtualizarSemApostilar()"
                            class="ml-1"
                            v-if="mostrarBtnAtualizar"
                        >
                            <span>
                                <i class="fa fa-edit mr-2"></i> Atualizar dados
                                gerais
                            </span>
                        </b-button>
                        <btn-obter-dados-rm
                            :contrato="contrato"
                            @obterContratoAtualizado="
                                obterContratoAtualizado(true)
                            "
                            v-if="mostrarBtnObterDadosRM"
                        >
                        </btn-obter-dados-rm>
                        <btn-voltar-etapa-contrato
                            :contrato="contrato"
                            @obterContratoAtualizado="
                                obterContratoAtualizado(true)
                            "
                            @retornarParaLista="retornarParaLista(true)"
                            @atualizarMensagensErros="erros = $event"
                        >
                        </btn-voltar-etapa-contrato>
                        <b-checkbox
                            class="pull-right"
                            v-if="mostrarCheckContratoComprovacao"
                            v-model="contratoComprovacao"
                            @change="selecionaContratoComprovacao($event)"
                            >Contrato com comprovação</b-checkbox
                        >
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import ContratosServicos from './ContratosServicos'
import ContratosRMServicos from '../rm/ContratosRMServicos'
import DocumentosServicos from './documentos/DocumentosServicos'
import ContratoDadosGerais from './ContratoDadosGerais'
import ContratoApostilamentos from './apostilamento/ContratoApostilamentos'
import DotacoesOrcamentarias from './dotacoesOrcamentarias/DotacoesOrcamentarias'
import ContratoResponsaveis from './responsaveis/ContratoResponsaveis'
import ItensContrato from './ItensContrato/ItensContrato'
import FasesContrato from './fasesContrato/FasesContrato'
import Documentos from './documentos/Documentos'
import BtnEncerrarContrato from './BtnEncerrarContrato'
import BtnCancelarContrato from './BtnCancelarContrato'
import BtnAlternarContrato from './BtnAlternarContrato'
import BtnDistribuirContrato from './BtnDistribuirContrato'
import BtnDistribuirAditivoContrato from './BtnDistribuirAditivoContrato'
import BtnIntegrarContrato from './BtnIntegrarContrato'
import BtnIntegrarAditivoContrato from './BtnIntegrarAditivoContrato'
import BtnObterDadosRm from './BtnObterDadosRM.vue'
import OcorrenciasInternas from './ocorrencias/OcorrenciasInternas'
import Penalidades from './penalidades/Penalidades'
import Comprometimentos from './comprometimentos/Comprometimentos'
import DadosRm from './dadosRM/dadosRM'
import { situacaoContrato } from './SituacaoContrato'
import HistoricoAditivos from './historicoAditivos/HistoricoAditivos'
import Avaliacoes from './avaliacoes/Avaliacoes'
import BtnVoltarEtapaContrato from './BtnVoltarEtapaContrato.vue'

export default {
    components: {
        AppContratoDadosGerais: ContratoDadosGerais,
        AppDadosRm: DadosRm,
        AppContratoApostilamentos: ContratoApostilamentos,
        AppContratoResponsaveis: ContratoResponsaveis,
        AppItensContrato: ItensContrato,
        AppFasesContrato: FasesContrato,
        AppDotacoesOrcamentarias: DotacoesOrcamentarias,
        AppDocumentos: Documentos,
        BtnEncerrarContrato,
        BtnCancelarContrato,
        BtnAlternarContrato,
        BtnDistribuirContrato,
        BtnDistribuirAditivoContrato,
        BtnIntegrarContrato,
        BtnIntegrarAditivoContrato,
        BtnObterDadosRm,
        OcorrenciasInternas,
        Penalidades,
        Comprometimentos,
        HistoricoAditivos,
        Avaliacoes,
        BtnVoltarEtapaContrato
    },

    data() {
        return {
            contrato: {},
            dadosRm: {},
            contratoComprovacao: false,
            operacao: 'DETALHAR',
            tabIndex: 0,
            erros: []
        }
    },

    methods: {
        voltar() {
            this.$router.push({ name: 'Contratos' })
        },

        obterContrato() {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterPorId(this.$route.params.contratoId).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.contrato = response.data
                            this.contratoComprovacao =
                                this.contrato.tipoEspecial
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterResponsaveisAtualizados() {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterResponsaveisPorContrato(
                this.$route.params.contratoId
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.contrato.responsaveisContrato = response.data
                        this.obterApostilamentosAtualizados()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterDotacoesAtualizadas() {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterDotacoesPorContrato(
                this.$route.params.contratoId
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.contrato.dotacoesOrcamentarias = response.data
                        this.obterApostilamentosAtualizados()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterFasesAtualizadas() {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterFasesPorContrato(
                this.$route.params.contratoId
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.contrato.fasesContrato = response.data.fases
                        this.contrato.totalFases = response.data.totalFases
                        this.contrato.valorDisponivelFases =
                            response.data.valorDisponivelFases
                        this.obterApostilamentosAtualizados()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterDocumentosAtualizados() {
            this.$store.dispatch('addRequest')
            DocumentosServicos.obterDocumentos(
                this.$route.params.contratoId
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.contrato.documentosContrato = response.data
                        this.obterApostilamentosAtualizados()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterApostilamentosAtualizados() {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterApostilamentosContrato(
                this.$route.params.contratoId
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.contrato.apostilamentos = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterComprometimentosAtualizados() {
            this.$refs.comprometimentos.obterComprometimentosBase()
        },

        obterContratoAtualizado(atualizarTabela) {
            if (atualizarTabela) {
                this.$store.dispatch('setRecarregar', true)
            }
            this.obterContrato()
        },

        retornarParaLista(atualizarTabela) {
            if (atualizarTabela) {
                this.$store.dispatch('setRecarregar', true)
            }
            this.$router.push({ name: 'Contratos' })
        },

        apostilarContrato() {
            this.$router.push({
                name: 'Contratos_Apostilar',
                params: {
                    contratoId: this.$route.params.contratoId,
                    apostilar: true
                }
            })
        },

        AtualizarContrato() {
            this.$router.push({
                name: 'Contratos_Atualizar',
                params: {
                    contratoId: this.$route.params.contratoId
                }
            })
        },

        AtualizarSemApostilar() {
            this.$router.push({
                name: 'Contratos_Atualizar_Sem_Apostilar',
                params: {
                    contratoId: this.$route.params.contratoId
                }
            })
        },

        AtualizarDadosRM() {
            this.$router.push({
                name: 'Contratos_Atualizar_DadosRM',
                params: {
                    contratoId: this.$route.params.contratoId
                }
            })
        },

        AditivarContrato() {
            this.$router.push({
                name: 'Contratos_Aditivar',
                params: {
                    contratoId: this.$route.params.contratoId
                }
            })
        },

        dotacaoOrcamentariaForm() {
            this.$router.push({
                name: 'Contratos_Dotacao',
                params: {
                    contratoId: this.$route.params.contratoId
                }
            })
        },

        verificaDotacaoOrcamentaria(contrato) {
            let tipoContrato = contrato.tipoContrato
            if (
                tipoContrato == 'MISTO' ||
                tipoContrato == 'POR ENTREGA' ||
                tipoContrato == 'PARCELA FIXA'
            ) {
                if (this.contrato.dotacoesOrcamentarias.length > 0) {
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        },

        selecionaContratoComprovacao(isTipoEspecial) {
            ContratosServicos.atualizarContratoComprovacao(
                this.contrato,
                isTipoEspecial
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Contrato com comprovação atualizado!',
                            'OK',
                            this.$toastConfig.success
                        )
                    } else {
                        this.erros = response.errors
                    }
                }
                // this.$store.dispatch('removeRequest')
            })
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        }
    },

    computed: {
        apostilamento() {
            return this.situacoesVigenteDistribuido()
        }
    },

    computed: {
        apostilamento() {
            return this.situacoesVigenteDistribuido()
        },

        encerradoCancelado() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_FINALIZADO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_CANCELADO
            )
        },

        contratoElaboracao() {
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        aditivoContratoIniciado() {
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.INICIADO_ADITIVO_CONTRATO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
            )
        },

        mostrarBtnObterDadosRM() {
            return this.tabIndex === 0 && this.situacoesVigenteDistribuido()
        },

        mostrarBtnApostilar() {
            return (
                this.tabIndex === 0 &&
                this.$temAcessoView('CONT-APOST-01') &&
                this.apostilamento &&
                this.contrato.contratoVigente
            )
        },

        mostrarCheckContratoComprovacao() {
            return (
                this.tabIndex === 0 &&
                this.$temAcessoView('CONT-ELAB-01') &&
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        mostrarBtnAtualizarElab() {
            return (
                this.tabIndex === 0 &&
                this.$temAcessoView('CONT-ELAB-00') &&
                (this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO)
            )
        },

        mostrarBtnAtualizar() {
            return (
                this.tabIndex === 0 &&
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido() &&
                this.contrato.contratoVigente
            )
        },

        mostrarBtnAtualizarDadosRM() {
            return (
                (this.tabIndex === 4 &&
                    this.$temAcessoView('CONT-ELAB-01') &&
                    (this.contrato.idSituacaoContrato ==
                        situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO ||
                        this.contrato.idSituacaoContrato ==
                            situacaoContrato.CONTRATO_DISTRIBUIDO)) ||
                (this.tabIndex === 4 &&
                    this.$temAcessoView('CONT-ADITIV-01') &&
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO) ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        mostrarBtnAtualizarAditivo() {
            return (
                this.tabIndex === 0 &&
                ( 
                    (this.$temAcessoView('CONT-ADITIV-00') &&
                        this.contrato.idSituacaoContrato ==
                            situacaoContrato.INICIADO_ADITIVO_CONTRATO)
                    || this.alteracaoTipoAditivo 
                )
            )
        },

        alteracaoTipoAditivo() {
            return this.$temAcessoView('CONT-ADITIV-01') &&
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO 
        },

        mostrarBtnEncerrarContrato() {
            return (
                (this.apostilamento || this.contrato.isAditivo) &&
                !this.encerradoCancelado &&
                this.$temAcessoView('CONT-02') &&
                this.contrato.contratoVigente &&
                this.tabIndex === 0 &&
                (this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_VIGENTE ||
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.CONTRATO_DISTRIBUIDO ||
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.ADITIVO_VIGENTE ||
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.ADITIVO_DISTRIBUIDO)
            )
        },

        mostrarBtnCancelarContrato() {
            return (
                !this.apostilamento &&
                !this.encerradoCancelado &&
                !this.contrato.isAditivo &&
                this.$temAcessoView('CONT-03') &&
                this.contrato.idContrato &&
                this.tabIndex === 0 &&
                (this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_VIGENTE ||
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.CONTRATO_DISTRIBUIDO ||
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.ADITIVO_VIGENTE ||
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.ADITIVO_DISTRIBUIDO)
            )
        },

        mostrarBtnDistribuirContrato() {            
            return (
                this.contrato.vcCodigoEstruturado != null &&
                this.contrato.fornecedor != null &&
                this.contrato.idTipoContrato != null &&
                this.contrato.dtInicioVigencia != null &&
                this.contrato.dtFimVigencia != null &&
                this.contrato.dtInicioPrazoExecucao != null &&
                this.contrato.dtFimPrazoExecucao != null &&                
                this.contrato.itensContrato.length > 0 &&
                this.contrato.documentosContrato.length > 0 &&                
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO &&
                this.tabIndex === 0
            )
        },

        mostrarBtnDistribuirAditivoContrato() {
            return (
                this.contrato.vcCodigoEstruturado != null &&
                this.contrato.fornecedor != null &&
                this.contrato.idTipoContrato != null &&
                this.contrato.dtInicioVigencia != null &&
                this.contrato.dtFimVigencia != null &&
                this.contrato.dtInicioPrazoExecucao != null &&
                this.contrato.dtFimPrazoExecucao != null &&
                this.contrato.dtEnvioFornecedor != null &&
                this.contrato.dtRetornoFornecedor != null &&
                this.contrato.dtEnvioDiretoria != null &&
                this.contrato.dtRetornoDiretoria &&
                this.contrato.itensContrato.length > 0 &&
                this.contrato.documentosContrato.length > 0 &&
                this.contrato.responsaveisContrato.length > 0 &&
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.INICIADO_ADITIVO_CONTRATO &&
                this.tabIndex === 0
            )
        },

        mostrarBtnIntegrarContrato() {
            return (
                this.contrato.vcCodigoEstruturado != null &&
                this.contrato.fornecedor != null &&
                this.contrato.idTipoContrato != null &&
                this.contrato.dtInicioVigencia != null &&
                this.contrato.dtFimVigencia != null &&
                this.contrato.dtInicioPrazoExecucao != null &&
                this.contrato.dtFimPrazoExecucao &&
                this.contrato.dtEnvioFornecedor != null &&
                this.contrato.dtRetornoFornecedor &&
                this.contrato.dtEnvioDiretoria != null &&
                this.contrato.dtRetornoDiretoria &&
                this.contrato.dadosContratoRM != null &&
                this.contrato.itensContrato.length > 0 &&
                this.contrato.documentosContrato.length > 0 &&
                this.contrato.responsaveisContrato.length > 0 &&
                this.contrato.totalFases > 0 &&
                this.verificaDotacaoOrcamentaria(this.contrato) &&
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO &&
                this.tabIndex === 0 &&
                this.$temAcessoView('CONT-ELAB-01')
            )
        },

        mostrarBtnIntegrarAditivoContrato() {
            return (
                this.contrato.vcCodigoEstruturado != null &&
                this.contrato.fornecedor != null &&
                this.contrato.idTipoContrato != null &&
                this.contrato.dtInicioVigencia != null &&
                this.contrato.dtFimVigencia != null &&
                this.contrato.dtInicioPrazoExecucao != null &&
                this.contrato.dtFimPrazoExecucao &&
                this.contrato.dtEnvioFornecedor != null &&
                this.contrato.dtRetornoFornecedor &&
                this.contrato.dtEnvioDiretoria != null &&
                this.contrato.dtRetornoDiretoria &&
                this.contrato.dadosContratoRM != null &&
                this.contrato.itensContrato.length > 0 &&
                this.contrato.documentosContrato.length > 0 &&
                this.contrato.responsaveisContrato.length > 0 &&
                this.contrato.totalFases > 0 &&
                this.verificaDotacaoOrcamentaria(this.contrato) &&
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO &&
                this.tabIndex === 0 &&
                this.$temAcessoView('CONT-ADITIV-01')
            )
        },

        mostrarBtnAlternarContrato() {
            return (
                this.apostilamento &&
                !this.encerradoCancelado &&
                this.$temAcessoView('CONT-04') &&
                this.contrato.ultimoContrato != null &&
                this.contrato.contratoVigente &&
                this.tabIndex === 0
            )
        },

        mostrarBtnAditivarContrato() {
            return (
                this.tabIndex === 0 &&
                (this.$temAcessoView('CONT-ADITIV-00') ||
                    this.$temAcessoView('CONT-ADITIV-01')) &&
                this.situacoesVigenteDistribuido() &&
                !this.contrato.aditivoIniciado &&
                this.contrato.vinculoRM
            )
        }
    },

    created() {
        this.obterContrato()
    },

    watch: {
        $route(to) {
            if (to.name === 'Contratos_Detalhar') {
                this.obterContrato()
                this.$store.dispatch('setRecarregar', false)
                this.tabIndex = 0
            }
        }
    }
}
</script>
